import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { PrimaryButton } from '@/styles/blocks';
import NavResponsiveModal, { ModalContent, ModalHeader } from '../../Navigation/NavResponsiveModal';

const OptionCard = ({ option }) => {
    const { label, description, actionLabel, onSelect } = option;

    return (
        <Grid
            item
            role="button"
            tabIndex={0}
            onClick={onSelect}
            onKeyDown={(e) => {
                if (onSelect && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    onSelect();
                }
            }}
            css={css`
                flex: 1 1 0;
                border: 1px solid ${colors.greys.border};
                border-radius: 4px;
                padding: 1.5rem 1rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                cursor: pointer;
                &:hover {
                    border-color: ${colors.greens.primary};
                }
            `}
        >
            <span
                css={css`
                    font-weight: 700;
                    font-size: 16px;
                `}
            >
                {label}
            </span>
            <span
                css={css`
                    color: ${colors.greys.secondary};
                    font-size: 14px;
                    margin-top: 0.75rem;
                    flex-grow: 1;
                `}
            >
                {description}
            </span>
            <span
                css={css`
                    margin-top: 1.25rem;
                    font-weight: 700;
                    font-size: 14px;
                    color: ${colors.greens.primary};
                `}
            >
                {`${actionLabel || `Select ${label}`} →`}
            </span>
        </Grid>
    );
};

const ChoiceModal = ({ open, title, subtitle, options = [], onClose, onBack }) => {
    return (
        <NavResponsiveModal maxWidth="md" open={open} onClose={onClose}>
            <ModalHeader
                css={css`
                    width: 560px;
                `}
                title={title}
                onClose={onClose}
            />
            <ModalContent
                css={css`
                    width: 560px;
                    padding-bottom: 1.5rem;
                `}
            >
                {subtitle ? (
                    <Grid
                        container
                        justifyContent="center"
                        css={css`
                            margin-bottom: 1.25rem;
                        `}
                    >
                        <span
                            css={css`
                                color: ${colors.greys.secondary};
                                font-size: 14px;
                            `}
                        >
                            {subtitle}
                        </span>
                    </Grid>
                ) : null}
                <Grid
                    container
                    direction="row"
                    css={css`
                        gap: 1rem;
                        flex-wrap: nowrap;
                        align-items: stretch;
                    `}
                >
                    {options.map((option) => (
                        <OptionCard key={option.label} option={option} />
                    ))}
                </Grid>
                {onBack ? (
                    <Grid
                        container
                        css={css`
                            margin-top: 1.25rem;
                        `}
                    >
                        <PrimaryButton onClick={onBack}>Back</PrimaryButton>
                    </Grid>
                ) : null}
            </ModalContent>
        </NavResponsiveModal>
    );
};

export default ChoiceModal;
